import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import SignUp from 'components/SignUp/SignUp';
import styles from './SignUp.module.scss';

export default class SignUpPage extends Component {
  static propTypes = {
    signUp: PropTypes.func,
  };

  render() {
    return (
      <div
        key="signup"
        id="this"
        className={'containers ' + styles.signUpContainer}
      >
        <Helmet title="Sign Up" />
        <h1 className={styles.title}>Sign Up to Twine</h1>
        <SignUp redirect={'onboarding'} redirectFromGoogle={'signup'} />
      </div>
    );
  }
}
